<script setup lang="ts">
import { ArrowRight, Check, Smartphone } from '../components/wx-icons'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { api } from '../services/api'
import { setAuth } from '../services/auth'
import { canRequestSms, canSubmitPhoneAuth } from '../services/auth-validation'

const route = useRoute()
const router = useRouter()
const phone = ref('')
const code = ref('')
const agreed = ref(false)
const sending = ref(false)
const loggingIn = ref(false)
const countdown = ref(0)
const error = ref('')
const canSend = computed(() => canRequestSms(phone.value, countdown.value, sending.value))
const canLogin = computed(() => canSubmitPhoneAuth(phone.value, code.value, agreed.value, sending.value, loggingIn.value))

async function sendCode() {
  if (!canSend.value) return
  error.value = ''
  sending.value = true
  try {
    const result: any = await api('/auth/web/phone/sms/request', { method: 'POST', body: JSON.stringify({ phone: phone.value }) })
    if (result?.devCode) code.value = String(result.devCode)
    countdown.value = Number(result?.cooldown || 60)
    const timer = window.setInterval(() => {
      countdown.value -= 1
      if (countdown.value <= 0) window.clearInterval(timer)
    }, 1000)
  } catch (reason: any) { error.value = reason?.message || '验证码发送失败' }
  finally { sending.value = false }
}

async function login() {
  if (!canLogin.value) return
  error.value = ''
  loggingIn.value = true
  try {
    const session: any = await api('/auth/web/phone/sms/verify', { method: 'POST', body: JSON.stringify({ phone: phone.value, code: code.value }) })
    setAuth(session)
    const redirect = typeof route.query.redirect === 'string' && route.query.redirect.startsWith('/') ? route.query.redirect : '/me'
    await router.replace(redirect)
  } catch (reason: any) { error.value = reason?.message || '注册/登录失败' }
  finally { loggingIn.value = false }
}
</script>

<template>
  <section class="login-page shell">
    <div class="login-visual"><div class="hero-court-lines"><span></span></div><div><span class="section-kicker">WELCOME</span><h1>下一场球，<br />从这里开始。</h1><p>注册或登录后，可以发布活动、报名球局、收藏场馆并查看自己的订场订单。</p></div></div>
    <form class="login-card" @submit.prevent="login">
      <div class="login-icon"><Smartphone :size="25" /></div><h2>手机号注册/登录</h2><p>未注册用户完成手机号验证后将自动注册。</p>
      <label>手机号<input v-model.trim="phone" inputmode="tel" maxlength="11" autocomplete="tel" placeholder="请输入中国大陆手机号" /></label>
      <label>验证码<div class="code-field"><input v-model.trim="code" inputmode="numeric" maxlength="6" autocomplete="one-time-code" placeholder="6 位验证码" /><button type="button" :disabled="!canSend" @click="sendCode">{{ countdown ? `${countdown}s` : sending ? '发送中' : '获取验证码' }}</button></div></label>
      <label class="agreement-check"><input v-model="agreed" type="checkbox" /><span><Check :size="14" /></span>我已阅读并同意服务协议与隐私政策</label>
      <p v-if="error" class="form-error">{{ error }}</p>
      <button class="button button-primary button-block button-large" :disabled="!canLogin" type="submit">{{ loggingIn ? '正在验证' : '注册/登录' }}<ArrowRight :size="18" /></button>
    </form>
  </section>
</template>
